// Formats shared by the call log, call detail and insights. Times are shown in the account time zone
// (src/design/timeZone.js), like the mockups' D.fmtTime / D.fmtDate.
import { calendarDay, formatInZone } from '../../design/timeZone';

const TIME = { hour: 'numeric', minute: '2-digit' };
const CLOCK = { hour: 'numeric', minute: '2-digit', second: '2-digit' };
const DAY = { weekday: 'short', month: 'short', day: 'numeric' };
const SHORT_DAY = { month: 'short', day: 'numeric' };
const LONG_DAY = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };

export const asDate = (value) => (value instanceof Date ? value : new Date(/Z|[+-]\d\d:\d\d$/.test(String(value)) ? value : `${value}Z`));

export const fmtTime = (value) => formatInZone(asDate(value), TIME);
export const fmtClock = (value) => formatInZone(asDate(value), CLOCK);
export const fmtDay = (value) => formatInZone(asDate(value), DAY);
export const fmtShortDay = (value) => formatInZone(asDate(value), SHORT_DAY);
export const fmtLongDay = (value) => formatInZone(asDate(value), LONG_DAY);

/** "Today", "Yesterday" or "Oct 13" relative to `now`, in the account time zone. */
export function relativeDay(value, now = new Date()) {
  const day = calendarDay(asDate(value));
  const today = calendarDay(now);
  const yesterday = calendarDay(new Date(now.getTime() - 86400000));
  if (day === today) return 'Today';
  if (day === yesterday) return 'Yesterday';
  return fmtShortDay(value);
}

export const ROUTE_KIND = {
  AutoAttendant: 'aa',
  Queue: 'queue',
  Agent: 'agent',
  Transfer: 'transfer',
  Voicemail: 'voicemail',
  Forward: 'forward',
  Abandoned: 'abandon',
  External: 'external',
};

export const routeKind = (type) => ROUTE_KIND[type] || 'external';

/** "7F3A-21C9": the first eight hex digits of the Teams call id, as the mockup's breadcrumb shows a call. */
export function shortCallId(id) {
  const hex = String(id || '').replace(/[^0-9a-f]/gi, '').slice(0, 8).toUpperCase();
  return hex.length === 8 ? `${hex.slice(0, 4)}-${hex.slice(4)}` : String(id || '');
}
